import dayjs from "dayjs";
import React, { useEffect, useState } from "react";

const EventPopup = ({ event, position, onClose }) => {
  const [popupDirection, setPopupDirection] = useState("down");

  const { title, resource, address, status, type, description } =
    event.data.appointment;
  let startDate = dayjs(event.start).format("D MMM YYYY");
  let endDate = dayjs(event.end).format("D MMM YYYY");

  useEffect(() => {
    const viewportHeight = window.innerHeight;

    // Determine if the popup should open upward or downward
    if (position.y + 300 > viewportHeight) {
      setPopupDirection("up");
    } else {
      setPopupDirection("down");
    }
  }, [position]);
  if (!event) return null;
  return (
    <div
      className={`event-popup ${popupDirection === "up" ? "up" : ""}`}
      style={{
        top: popupDirection === "up" ? position.y - 10 : position.y + 10,
        left: position.x,
      }}
    >
      <div className="event-popup-close cursor" onClick={() => onClose()}>
        <img
          src={`${process.env.PUBLIC_URL}/assets/Close.svg`}
          alt="close"
          className="event-popup-close-img"
        />
      </div>
      <div
        className={
          status === "done"
            ? "event-popup-header event-popup-header-done"
            : `event-popup-header event-popup-header-upcoming`
        }
      >
        <p>{title}</p>
        <div className="event-popup-status">
          <img
            src={
              status === "done"
                ? `${process.env.PUBLIC_URL}/assets/done.svg`
                : `${process.env.PUBLIC_URL}/assets/upcoming.svg`
            }
            alt="status"
          />
          <div className="ms-1">{status}</div>
        </div>
      </div>
      <div className="event-popup-body">
        <div className="flex-row w-100 items-center gap-2 event-body-container">
          <img src={`${process.env.PUBLIC_URL}/assets/locationPopup.svg`} />
          <p className="event-popup-body-p">{address}</p>
        </div>

        <div className="flex-row w-100 items-center gap-2 event-body-container">
          <img src={`${process.env.PUBLIC_URL}/assets/timePopup.svg`} />
          <p className="event-popup-body-p">
            {startDate} - {endDate}
          </p>
        </div>

        <div className="flex-row w-100 items-center gap-2 event-body-container">
          <img src={`${process.env.PUBLIC_URL}/assets/fix.svg`} />
          <p className="event-popup-body-p">{type}</p>
        </div>
        <div className="flex-row w-100 items-center gap-2 event-body-container">
          <img src={`${process.env.PUBLIC_URL}/assets/doc.svg`} />
          <p className="event-popup-body-p">{description}</p>
        </div>
      </div>
    </div>
  );
};

export default EventPopup;
